export default __webpack_public_path__ + "static/Saly-17-841a2cdc40395b8969834158437f95e6.png";